
export default {
  GLOBAL_ALERT                    : 'globalAlertReducer',
  ORDER                           : 'orderReducer',
  TRANSLATION                     : 'translationReducer',
  COUNTDOWN                       : 'countdownReducer',
};
